<msi-toast position="top-center" [preventOpenDuplicates]="true" />

@if (!appReady) {
<div>
  <p-progress-spinner size="large" />
</div>
} @else {
@if (!startupError) {
<p-tabs [(value)]="activeIndex" (valueChange)="updateActiveIndex($event)" class="tabs-container">
  <p-tablist class="tabs-list-container">
    <p-tab [value]=0>{{ PremiseHazardTabText }}</p-tab>
    <p-tab [value]=1>{{ PremiseHazardTypeTabText }}</p-tab>
    <p-tab [value]=2>{{ OrganizationTabText }}</p-tab>
  </p-tablist>
  <p-tabpanels class="tabs-panels-container">
    @if (ComponentLoading) {
    <p-progress-spinner size="large" />
    } @else {
    <div class="router-outlet-container">
      <router-outlet></router-outlet>
    </div>
    }
  </p-tabpanels>
</p-tabs>
} @else {
<div>An error occurred starting the application, an error message should have appeared</div>
}
}

<p-confirmdialog #cd [closable]="false">
  <ng-template pTemplate="message" let-confirmation>
    <span [innerHTML]="confirmation.message"></span>
  </ng-template>
  <ng-template pTemplate="footer">
    <button type="button" pButton [text]="true" (click)="cd.onReject()">
      {{ cd.confirmation?.rejectLabel || ('Buttons.cancel' | transloco) }}
    </button>
    <button type="button" pButton (click)="cd.onAccept()">
      {{ cd.confirmation?.acceptLabel || ('Buttons.delete' | transloco) }}
    </button>
  </ng-template>
</p-confirmdialog>